// Dates robustes : l'API REST sérialise les timestamps Drizzle en chaîne ISO,
// alors que les events Socket.IO envoient des secondes Unix. On accepte les deux
// (+ millisecondes) pour ne plus jamais afficher "Invalid Date".
export function toDate(value: number | string | null | undefined): Date | null {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "string") {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  // Nombre : secondes (< 1e12) ou millisecondes.
  const ms = value < 1e12 ? value * 1000 : value;
  const d = new Date(ms);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function toMs(value: number | string | null | undefined): number {
  return toDate(value)?.getTime() ?? Date.now();
}

export function formatDateTime(
  value: number | string | null | undefined,
  opts: Intl.DateTimeFormatOptions = {},
): string {
  const d = toDate(value);
  return d ? d.toLocaleString("fr-CA", opts) : "—";
}

export function formatTime(value: number | string | null | undefined): string {
  const d = toDate(value);
  return d ? d.toLocaleTimeString("fr-CA") : "—";
}
